module.exports = __webpack_public_path__ + "img/team1.f0164a21.png";